import APIFetcher from '../APIFetcher';

class SessionApi {
  static signIn(credentials) {
    return APIFetcher.post('session/', {payload: credentials});
  }

  static signOut() {
    return APIFetcher.remove('session/');
  }
}

export default SessionApi;
